exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fontDiv p[data-v-49bba76c]{line-height:30px}.sorry[data-v-49bba76c]{font-size:16px;font-weight:bold;color:#333333}.fail_reason[data-v-49bba76c]{font-size:14px;color:#666666}\n", ""]);

// exports
